import { useTranslation } from 'react-i18next';
import { eIntegrationType } from '../../../../../../../../providers/IntegrationsProvider/Integrations.enums.ts';
import { useSyncConversationsContext } from '../../../../../../../../providers/SyncConversationsProvider/SyncConversations.context.tsx';
import { tConversation } from './Conversation.types.ts';

export default function Conversation(props: tConversation) {
  const { selectedIntegration } = useSyncConversationsContext();
  const { t } = useTranslation('dashboard/dashboard');

  const transformDate = () => {
    const newDate = new Date(props.updatedAt);
    return `${newDate.getDate()}/${newDate.getMonth()}/${newDate.getFullYear()} ${newDate.getHours()}:${newDate.getMinutes()}`;
  };

  const isGroupOrNumber = () => {
    if (props.handle.endsWith('@g.us')) {
      return t('components.modals.SyncConversations.select.group');
    }
    return props.handle.split('@')[0];
  };

  return (
    <div
      className={`${props.index % 2 === 0 ? 'bg-primary/20' : 'bg-primary/10'}  w-full grid grid-cols-2 p-2 items-center`}
    >
      <div className="flex flex-col px-2 gap-1">
        <p>{props.name}</p>
        {selectedIntegration === eIntegrationType.WHATSAPP_WEB && (
          <p className="text-xs">({isGroupOrNumber()})</p>
        )}
      </div>
      <p className="mx-auto">{transformDate()}</p>
    </div>
  );
}
